import type { Flow } from '@/parcours/flowGlobalSteps';
import { healthWomenFlow } from './healthWomen.flow';
import { stressFlow } from './stress/stress.flow';
import { mcvFlow } from '@/parcours/flows/mcv/mcv.flow';
import { breastCancerFlow } from '@/parcours/flows/breastCancer/breastCancer.flow';
import { melanomaFlow } from '@/parcours/flows/melanoma/melanoma.flow';
import { preventionFlow } from '@/parcours/flows/prevention/prevention.flow';
import { vaccinationAndCovidFlow } from '@/parcours/flows/vaccination-and-covid/vaccin-and-covid.flow';
import { healthMenFlow } from '@/parcours/flows/healthMan/healthMen.flow';
import { fluFlow } from '@/parcours/flows/vaccination-and-covid/vaccination.flow';
import { covidFlow } from '@/parcours/flows/vaccination-and-covid/covid.flow';
import { novartisFlow } from '@/parcours/flows/novartis/novartis.flow';
import { laboFlow } from '@/parcours/flows/labo/labo.flow';
import { tmsFlow } from '@/parcours/flows/tms/tms.flow';
import { endometriosisFlow } from '@/parcours/flows/endometriosis/endometriosis.flow';

export const flows: Record<string, Flow> = {
  healthWomenFlow,
  stressFlow,
  mcvFlow,
  breastCancerFlow,
  melanomaFlow,
  covidFlow,
  fluFlow,
  vaccinationAndCovidFlow,
  preventionFlow,
  healthMenFlow,
  novartisFlow,
  laboFlow,
  tmsFlow,
  endometriosisFlow,
};
